import { ToggleSwitch } from '../../components/ToggleSwitch'
import { UserOrganizationListCell } from '../../components/UserOrganizationListCell'
import {
  SHOULD_INCLUDE_GLOBAL_ROLE_COLUMN,
  SHOULD_INCLUDE_ORGANIZATION_COLUMN,
  TableOptions,
  TableOptionValues,
  TogglePropertyType,
} from '../../configs/constants'
import { UserObj } from '../../store/slices/userlist/slice'
import { GlobalRoleCell } from '../../components/GlobalRoleCell'

export const USERLIST_COLUMNS_CONFIG = [
  {
    [TableOptions.accessorKey]: TableOptionValues.id,
    [TableOptions.header]: 'ID',
  },
  {
    [TableOptions.accessorKey]: TableOptionValues.firstName,
    [TableOptions.header]: 'First Name',
  },
  {
    [TableOptions.accessorKey]: TableOptionValues.lastName,
    [TableOptions.header]: 'Last Name',
  },
  {
    [TableOptions.accessorKey]: TableOptionValues.email,
    [TableOptions.header]: 'Email',
  },
  SHOULD_INCLUDE_ORGANIZATION_COLUMN && {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [TableOptions.cell]: ({ row }: any) => {
      return <UserOrganizationListCell groups={row.original.groups} />
    },
    [TableOptions.header]: 'Organization (s)',
  },
  {
    [TableOptions.cell]: ({ row }: { row: { original: UserObj } }) => {
      return (
        <ToggleSwitch
          user={row.original}
          property={TogglePropertyType.enabled}
          value={!row.original.enabled}
        />
      )
    },
    [TableOptions.header]: 'Enabled',
  },
  SHOULD_INCLUDE_GLOBAL_ROLE_COLUMN && {
    [TableOptions.cell]: ({ row }: { row: { original: UserObj } }) => {
      return (
        <GlobalRoleCell
          userId={row.original.id}
          role={row.original.globalRole}
        />
      )
    },
    [TableOptions.header]: 'Global Role',
    [TableOptions.id]: 'Global Role',
  },
  {
    [TableOptions.cell]: ({ row }: { row: { original: UserObj } }) => {
      return (
        <ToggleSwitch
          user={row.original}
          property={TogglePropertyType.portalAdmin}
          value={!row.original.portalAdmin}
        />
      )
    },
    [TableOptions.header]: 'Portal Admin',
  },
].filter((v) => v)
